const FactsSection = ({item}) => {
    return (
        <>
            <div className="article-card">
                <h2 className="article-card-title">{item?.title}</h2>
                
                <p className="article-card-desc desc-color">
                    {item?.highIntent}
                </p>
                
                <p className="article-card-desc">{item?.desc1}</p>
                <p className="article-card-desc">{item?.desc2}</p>
                
                <p className="article-card-desc desc-color">
                    <strong>{item?.quickQuestionTitle}</strong> {item?.quickQuestion}
                </p>
                
                <p className="article-card-desc">{item?.desc3}</p>
            </div>
        </>
    )
}

export default FactsSection;